"use strict"

import React, {useState} from "react"
import {observer} from "mobx-react"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import ReCAPTCHA from "react-google-recaptcha"
import config from "../../global/config/settings"

import {handleLogin} from "../../global/helpers/actions"
import {Grid, Paper, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsButton from "../../global/ui/xsButton/xsButton"

import {isPasswordValid} from "../../global/helpers/functions"

import LoginStore from "./loginStore"
// import RouterStore from "../../global/store/RouterStore"
import GlobalStore from "../../global/store/GlobalStore"
import ErrorStore from "../../global/store/ErrorStore"

function Login() {
	const hooks = {
		onSubmit(form) {
			const {log_in, password} = form.values()

			if (isEmpty(log_in) || isEmpty(password)) {
				GlobalStore.setNotificationMessage("Text.emptyFields", "", "warning")

				form.invalidate()
			} else {
				if (!isPasswordValid(password)) {
					GlobalStore.setNotificationMessage(
						"Heslo musí obsahovať aspoň jedno veľké písmeno, jedno malé písmeno a jednu číslicu. Minimálna dĺžka hesla je 8 znakov.",
						"",
						"warning"
					)
					form.$("password").invalidate()
				}
			}
		},
		onSuccess(form) {
			const {log_in, password} = form.values()
			handleLogin(log_in, password)
		},
		onError() {
			// GlobalStore.setNotificationMessage("Heslo je povinné pole!", "", "warning")
		}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					log_in: {label: "Prihlasovacie meno", rules: "email|string"},
					password: {label: "Heslo", type: "password"}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item className="textCenter">
				<Typography variant="h3">Prihlásenie</Typography>
			</Grid>
			<Grid item>
				<Paper variant="elevation" style={{backgroundColor: "transparent"}}>
					<Box p={2}>
						<Grid container direction="column" spacing={4}>
							<Grid item>
								<Typography variant="body2">
									Prihláste sa pomocou emailovej adresy a hesla, ktoré ste zadali počas registrácie.
								</Typography>
							</Grid>
							<Grid item>
								<XsInput field={form.$("log_in")} autoFocus={true} submitAction={(e) => form.onSubmit(e)} />
							</Grid>
							<Grid item>
								<XsInput
									regex={(val) => isPasswordValid(val)}
									type="password"
									field={form.$("password")}
									submitAction={(e) => form.onSubmit(e)}
								/>
								{ErrorStore.incorectLoginOrPassword && (
									<div className="redDanger fontSize14 mt-2">Nesprávne prihlasovacie meno alebo heslo</div>
								)}
							</Grid>
						</Grid>
						<Grid container direction="column" spacing={2} className="mt-2">
							<Grid item>
								<XsButton text="Prihlásiť" onClick={form.onSubmit} />
							</Grid>
							{GlobalStore.enabledRecaptchaV2 && (
								<Grid item>
									<ReCAPTCHA
										sitekey={config.SITE_KEY_V2 || ""}
										onChange={(token) => {
											GlobalStore.tokenRecaptchaV2 = token
										}}
									/>
								</Grid>
							)}
							<Grid item>
								<Link
									variant="body2"
									className="pointer"
									onClick={() => {
										// logger("....recaptchaRef...", recaptchaRef.current.getValue())
										LoginStore.screen = LoginStore.screens.FORGOT
									}}
								>
									Zabudli ste heslo? (Reset hesla pre existujúce konto)
								</Link>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	)
}

export default injectIntl(observer(Login))

